export const SET_RESIDENTS_LIST = 'SET_RESIDENTS_LIST';

export const setResidents = (residents, totalItemsCount) => ({
  type: SET_RESIDENTS_LIST,
  residents,
  totalItemsCount,
});
